import React from 'react';
import './App.css';
import NavBar from './components/NavBar';
import HomePage from './components/HomePage';
import PartnerWithUs from './components/PartnerWithUs';
import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';
import Career from './components/Career';
// ✅ These should be at the top
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ScrollToTop from './components/ScrollToTop';
import BlogSection from './components/BlogSection';
import CompleteBlog from './components/CompleteBlog';
import 'bootstrap-icons/font/bootstrap-icons.css';
import InstituteManagement from './components/InstituteManagement';
import SchoolManagement from './components/SchoolManagement';
import LearningManagement from './components/LearningManagement';
import BlogPostCard from './components/BlogPostCard';
import WebsiteDev from './components/WebsiteDev';
import ContactPage from './components/ContactPage';
import ChatBot from './components/ChatBot';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import ScrollTopButton from './components/ScrollTopButton';
import E_LearningPrivacy from './components/E_learningPrivacy';



function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-partners" element={<PartnerWithUs />} />
          <Route path="/career" element={<Career />} />
          <Route path="/blogs.warals" element={<BlogSection />} />
          <Route path="/warals-institute-management-system" element={<InstituteManagement />} />
          <Route path="/warals-school-management-system" element={<SchoolManagement />} />
          <Route path="/warals-learning-management-system" element={<LearningManagement />} />
          <Route path="/warals-website-develop" element={<WebsiteDev />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/elearning-privacy-policy" element={<E_LearningPrivacy />} />
         
        </Routes>
        <ChatBot />
        <ScrollTopButton/>
      </div>
    </Router>
  );
}

export default App;